import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LabelOverlay from 'components/Markup/LabelOverlay'
import { updateUiAction } from 'actions/uiActions'
import { addMarkupAction } from 'actions/markupActions'
import { notificationAction } from 'actions/notificationActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import { DEFAULT_SHAPE_OPTIONS, DEFAULT_LABEL_DIMENSIONS, DEFAULT_WALL_OPTIONS } from 'helpers/globals'
import determineLocationOfNewLabel from 'helpers/map/determineLocationOfNewLabel'
import wiredDeviceDefaults from 'helpers/wiredDevices/defaults'
import { labelsSelector } from 'selectors/components'

const { CIRCLE, POLYGON, POLYLINE, RECTANGLE } = google.maps.drawing.OverlayType

const mapStateToProps = state => {
  const { map: { ref } } = state

  return {
    map: ref,
    labels: labelsSelector(state)
  }
}

class DefaultButtons extends React.Component {
  state = { showAddList: this.props.highlightAddNetworkCloset }

  componentDidMount = _ =>
    window.addEventListener('click', this.windowClick)

  componentWillUnmount = _ => {
    window.removeEventListener('click', this.windowClick)
    if (this.drawingManager) this.drawingManager.setMap(null)
  }

  componentWillUpdate(nextProps) {
    if (!this.drawingManager && nextProps.map) {
      this.drawingManager = new google.maps.drawing.DrawingManager({
        map: nextProps.map,
        drawingControl: false,
        markerOptions: DEFAULT_SHAPE_OPTIONS,
        circleOptions: DEFAULT_SHAPE_OPTIONS,
        polygonOptions: DEFAULT_SHAPE_OPTIONS,
        polylineOptions: DEFAULT_SHAPE_OPTIONS,
        rectangleOptions: DEFAULT_SHAPE_OPTIONS
      })
      google.maps.event.addListener(this.drawingManager, 'overlaycomplete', e => {
        this.drawingManager.setDrawingMode(null)
        this.props.addMarkupAction(e.type, e.overlay)
      })

      this.wallManager = new google.maps.drawing.DrawingManager({
        map: nextProps.map,
        drawingControl: false,
        polylineOptions: {
          ...DEFAULT_WALL_OPTIONS,
          strokeColor: '#000000'
        }
      })
      google.maps.event.addListener(this.wallManager, 'overlaycomplete', e => {
        this.wallManager.setDrawingMode(null)
        this.props.addMarkupAction('wall', e.overlay)
      })
    }
  }

  windowClick = event => {
    if (this.state.showAddList) {
      if (this.refs.addListButton.contains(event.target)) return
      this.setState({ showAddList: false })
    }
  }

  activateLabelInsertMode = _ => {
    const { map, labels, addMarkupAction } = this.props
    const location = determineLocationOfNewLabel({ map, labels })

    const overlay = new LabelOverlay({ dimensions: Object.assign({}, DEFAULT_LABEL_DIMENSIONS), location, enableEditMode: true, draggable: true })
    addMarkupAction('label', overlay)
  }

  render() {
    const { activateLabelInsertMode, state: { showAddList }, props: { highlightAddNetworkCloset, checkOfflineLimitsAction,
      updateUiAction, notificationAction, classes } } = this

    return (
      <div className={classes.bottomBar}>
        <div className={classes.buttonWrapper}>
          <div
            onClick={_ => checkOfflineLimitsAction('createCamera')}
            className={classes.addCameraButton}
          >
            <FontAwesomeIcon icon='plus' className={classes.addIcon} />
            Camera
          </div>
          <div
            onClick={_ => checkOfflineLimitsAction('modal', ['MobileFloorPlanUploader'])}
            className={classes.addFloorplanButton}
          >
            <FontAwesomeIcon icon='plus' className={classes.addIcon} />
            Floor Plan
          </div>
          <div
            onClick={_ => this.setState({ showAddList: !showAddList })}
            className={showAddList ? classes.moreButtonSelected : classes.moreButton}
            ref='addListButton'
          >
            <FontAwesomeIcon icon='ellipsis-v' className={classes.moreIcon} />
          </div>
          {
            showAddList &&
            <div className={classes.addList}>
              <div onClick={_ => {
                if (this.wallManager) {
                  this.wallManager.setDrawingMode(POLYLINE)
                  notificationAction('Double tap to complete wall', 'info')
                  updateUiAction({ showWallBlindspots: true })
                }
              }}>
                <FontAwesomeIcon icon={['fac', 'wall']} className={classes.icon} />
                <span>Draw Wall</span>
              </div>
              <div onClick={activateLabelInsertMode}>
                <FontAwesomeIcon icon='comment' className={classes.icon} />
                <span>Add Label</span>
              </div>
              <div onClick={_ => this.drawingManager && this.drawingManager.setDrawingMode(CIRCLE)}>
                <FontAwesomeIcon icon={['far', 'circle']} className={classes.icon} />
                <span>Draw Circle</span>
              </div>
              <div onClick={_ => {
                this.drawingManager && this.drawingManager.setDrawingMode(POLYGON)
                notificationAction('Tap starting point to close polygon', 'info')
              }}>
                <FontAwesomeIcon icon='draw-polygon' className={classes.icon} />
                <span>Draw Polygon</span>
              </div>
              <div onClick={_ => {
                this.drawingManager && this.drawingManager.setDrawingMode(POLYLINE)
                notificationAction('Double tap to complete line', 'info')
              }}>
                <FontAwesomeIcon icon='wave-square' className={classes.icon} />
                <span>Draw Line</span>
              </div>
              <div onClick={_ => this.drawingManager && this.drawingManager.setDrawingMode(RECTANGLE)}>
                <FontAwesomeIcon icon='vector-square' className={classes.icon} />
                <span>Draw Rectangle</span>
              </div>
              <div onClick={_ => checkOfflineLimitsAction('addNetworkCloset')} className={highlightAddNetworkCloset ? 'highlight' : ''} style={{ position: 'relative' }}>
                <FontAwesomeIcon icon='server' className={classes.icon} />
                <span>Add Network Closet</span>
                { highlightAddNetworkCloset && <FontAwesomeIcon icon='long-arrow-alt-right' className={classes.highlightArrow} /> }
              </div>
              <div onClick={_ => checkOfflineLimitsAction('addWiredDevice', [wiredDeviceDefaults.type])}>
                <FontAwesomeIcon icon={['far', 'ethernet']} className={classes.icon} />
                <span>Add Other Device</span>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkOfflineLimitsAction, updateUiAction, addMarkupAction, notificationAction })(injectSheet(style)(DefaultButtons))



// WEBPACK FOOTER //
// ./src/components/BottomBar/Buttons/index.js